import { format } from 'date-fns';
import receiptline from 'receiptline';
import ICashFlow from '~/interfaces/ICashFlow';
import ICompany from '~/interfaces/ICompany';
import IOrder from '~/interfaces/IOrder';
import getCurrencyFormatted from './getCurrencyFormatted';

interface getPrintCashFlowHTMLProps {
  company: ICompany;
  launchs: ICashFlow[];
  orders: IOrder[];
}

export function getPrintCashFlowEscPos({
  company,
  launchs,
  orders,
}: getPrintCashFlowHTMLProps) {
  const openedAt = launchs.find(item => item.type === '100');

  if (!openedAt) {
    throw new Error('Atenção! O caixa não foi aberto.');
  }

  const openedAtDate = format(
    new Date((openedAt.date as any).seconds * 1000),
    'dd/MM/yyyy HH:mm',
  );

  const closedAt = launchs.find(item => item.type === '99');

  // if (!closedAt) {
  //   throw new Error('Atenção! O caixa não foi fechado.');
  // }

  const closedAtDate = closedAt
    ? format(
        new Date((closedAt.date as any).seconds * 1000),
        'dd/MM/yyyy HH:mm',
      )
    : format(new Date(), 'dd/MM/yyyy HH:mm');

  let suppliesBalance = 0;
  let sangriaBalance = 0;

  launchs.forEach(item => {
    if (item.type === '1') suppliesBalance += item.value;
    if (item.type === '0') sangriaBalance += item.value;
  });

  const resumeSales = {
    moneyBalance: 0,
    pixBalance: 0,
    creditBalance: 0,
    debitBalance: 0,
    total: 0,
  };

  const resumeSalesDelivery = {
    moneyBalance: 0,
    pixBalance: 0,
    creditBalance: 0,
    debitBalance: 0,
    taxBalance: 0,
    valueProducts: 0,
    total: 0,
  };

  const resumeSalesLocal = {
    moneyBalance: 0,
    pixBalance: 0,
    creditBalance: 0,
    debitBalance: 0,
    total: 0,
  };

  const resumeSalesTable = {
    moneyBalance: 0,
    pixBalance: 0,
    creditBalance: 0,
    debitBalance: 0,
    total: 0,
  };

  orders.forEach(item => {
    // retirada local
    if (
      item.order_type === '0' &&
      !item.table &&
      !item.name.toLowerCase().includes('mesa')
    ) {
      if (item.paymentMethod === '0')
        resumeSalesLocal.moneyBalance += item.total;
      if (item.paymentMethod === '1')
        resumeSalesLocal.debitBalance += item.total;
      if (item.paymentMethod === '2')
        resumeSalesLocal.creditBalance += item.total;
      if (item.paymentMethod === '3') resumeSalesLocal.pixBalance += item.total;

      item.orderPayments.forEach(payment => {
        if (payment.payment_method_id === '0')
          resumeSalesLocal.moneyBalance += item.total;
        if (payment.payment_method_id === '1')
          resumeSalesLocal.debitBalance += item.total;
        if (payment.payment_method_id === '2')
          resumeSalesLocal.creditBalance += item.total;
        if (payment.payment_method_id === '3')
          resumeSalesLocal.pixBalance += item.total;
      });
    }

    // mesas
    if (
      item.order_type === '2' ||
      item.table ||
      item.name.toLowerCase().includes('mesa')
    ) {
      if (item.paymentMethod === '0')
        resumeSalesTable.moneyBalance += item.total;
      if (item.paymentMethod === '1')
        resumeSalesTable.debitBalance += item.total;
      if (item.paymentMethod === '2')
        resumeSalesTable.creditBalance += item.total;
      if (item.paymentMethod === '3') resumeSalesTable.pixBalance += item.total;

      if (item.orderPayments) {
        item.orderPayments.forEach(payment => {
          if (payment.payment_method_id === '0')
            resumeSalesTable.moneyBalance += item.total;
          if (payment.payment_method_id === '1')
            resumeSalesTable.debitBalance += item.total;
          if (payment.payment_method_id === '2')
            resumeSalesTable.creditBalance += item.total;
          if (payment.payment_method_id === '3')
            resumeSalesTable.pixBalance += item.total;
        });
      }
    }

    // delivery
    if (item.order_type === '1') {
      resumeSalesDelivery.taxBalance += item.shippingCost;

      if (item.paymentMethod === '0')
        resumeSalesDelivery.moneyBalance += item.total;
      if (item.paymentMethod === '1')
        resumeSalesDelivery.debitBalance += item.total;
      if (item.paymentMethod === '2')
        resumeSalesDelivery.creditBalance += item.total;
      if (item.paymentMethod === '3')
        resumeSalesDelivery.pixBalance += item.total;

      if (item.orderPayments) {
        item.orderPayments.forEach(payment => {
          if (payment.payment_method_id === '0')
            resumeSalesDelivery.moneyBalance += item.total;
          if (payment.payment_method_id === '1')
            resumeSalesDelivery.debitBalance += item.total;
          if (payment.payment_method_id === '2')
            resumeSalesDelivery.creditBalance += item.total;
          if (payment.payment_method_id === '3')
            resumeSalesDelivery.pixBalance += item.total;
        });
      }
    }

    if (item.paymentMethod === '0') resumeSales.moneyBalance += item.total;
    if (item.paymentMethod === '1') resumeSales.debitBalance += item.total;
    if (item.paymentMethod === '2') resumeSales.creditBalance += item.total;
    if (item.paymentMethod === '3') resumeSales.pixBalance += item.total;

    if (item.orderPayments) {
      item.orderPayments.forEach(payment => {
        if (payment.payment_method_id === '0')
          resumeSales.moneyBalance += item.total;
        if (payment.payment_method_id === '1')
          resumeSales.debitBalance += item.total;
        if (payment.payment_method_id === '2')
          resumeSales.creditBalance += item.total;
        if (payment.payment_method_id === '3')
          resumeSales.pixBalance += item.total;
      });
    }
  });

  const valueInCash =
    openedAt.value +
    suppliesBalance -
    sangriaBalance +
    resumeSales.moneyBalance;

  resumeSales.total =
    resumeSales.moneyBalance +
    resumeSales.pixBalance +
    resumeSales.creditBalance +
    resumeSales.debitBalance;

  resumeSalesDelivery.total =
    resumeSalesDelivery.moneyBalance +
    resumeSalesDelivery.pixBalance +
    resumeSalesDelivery.creditBalance +
    resumeSalesDelivery.debitBalance;

  resumeSalesDelivery.valueProducts =
    resumeSalesDelivery.total - resumeSalesDelivery.taxBalance;

  resumeSalesLocal.total =
    resumeSalesLocal.moneyBalance +
    resumeSalesLocal.pixBalance +
    resumeSalesLocal.creditBalance +
    resumeSalesLocal.debitBalance;

  resumeSalesTable.total =
    resumeSalesTable.moneyBalance +
    resumeSalesTable.pixBalance +
    resumeSalesTable.creditBalance +
    resumeSalesTable.debitBalance;

  let doc = `"${company.fantasy}

RELATÓRIO DE CAIXA

|ABERTO EM | FECHADO EM
|${openedAtDate} | ${closedAtDate}

|"RESUMO DO CAIXA

|SALDO INICIAL | ${openedAt.value_formatted}
|SUPRIMENTOS | ${getCurrencyFormatted(suppliesBalance)}
|SANGRIAS | ${getCurrencyFormatted(sangriaBalance)}
|VENDAS EM DINHEIRO | ${getCurrencyFormatted(resumeSales.moneyBalance)}
|VALOR EM CAIXA  | ${getCurrencyFormatted(valueInCash)}

|"RESUMO DAS VENDAS

|DINHEIRO | ${getCurrencyFormatted(resumeSales.moneyBalance)}
|PIX | ${getCurrencyFormatted(resumeSales.pixBalance)}
|CRÉDITO | ${getCurrencyFormatted(resumeSales.creditBalance)}
|DÉBITO | ${getCurrencyFormatted(resumeSales.debitBalance)}
|TOTAL  | ${getCurrencyFormatted(resumeSales.total)}

|"VENDAS DELIVERY

|DINHEIRO | ${getCurrencyFormatted(resumeSalesDelivery.moneyBalance)}
|PIX | ${getCurrencyFormatted(resumeSalesDelivery.pixBalance)}
|CRÉDITO | ${getCurrencyFormatted(resumeSalesDelivery.creditBalance)}
|DÉBITO |${getCurrencyFormatted(resumeSalesDelivery.debitBalance)}

|VALOR DOS PRODUTOS | ${getCurrencyFormatted(resumeSalesDelivery.valueProducts)}
|TAXA DE ENTREGA | ${getCurrencyFormatted(resumeSalesDelivery.taxBalance)}
|TOTAL | ${getCurrencyFormatted(resumeSalesDelivery.total)}

|"VENDAS RETIRADA

|DINHEIRO | ${getCurrencyFormatted(resumeSalesLocal.moneyBalance)}
|PIX | ${getCurrencyFormatted(resumeSalesLocal.pixBalance)}
|CRÉDITO | ${getCurrencyFormatted(resumeSalesLocal.creditBalance)}
|DÉBITO | ${getCurrencyFormatted(resumeSalesLocal.debitBalance)}
|TOTAL  | ${getCurrencyFormatted(resumeSalesLocal.total)}

|"VENDAS MESAS

|DINHEIRO | ${getCurrencyFormatted(resumeSalesTable.moneyBalance)}
|PIX | ${getCurrencyFormatted(resumeSalesTable.pixBalance)}
|CRÉDITO | ${getCurrencyFormatted(resumeSalesTable.creditBalance)}
|DÉBITO | ${getCurrencyFormatted(resumeSalesTable.debitBalance)}
|TOTAL  | ${getCurrencyFormatted(resumeSalesTable.total)}

TECNOLOGIA
WWW.TEM-PEDIDO.WEB.APP


`;

  doc = doc.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  const printer = {
    cpl: 48,
    encoding: 'multilingual',
    upsideDown: false,
    gamma: 1.8,
    command: 'escpos',
    spacing: true,
  } as receiptline.Printer;

  const command = receiptline.transform(doc, printer);

  return command;
}
